import historyImage from "../images/history.svg";
import infiniteImage from "../images/infinite.svg";
import { ValidityPeriodIconEnum } from "../enums/ValidityPeriodIconEnum";
import { getValidityPeriodDisplay } from "./getValidityPeriodDisplay";
import { DetailCard } from "@hatch-digital-nl/abs-storybook/legacy";
import { ComponentProps } from "react";

type DetailCardLabelMetadataItem = Extract<
    NonNullable<ComponentProps<typeof DetailCard>["metadata"]>[number],
    { type: "label" }
>;

interface Props {
    expiresAt?: string;
}

export const getValidityPeriodMetaItem = (
    props: Props,
): DetailCardLabelMetadataItem => {
    const { text, icon } = getValidityPeriodDisplay({
        expiresAt: props.expiresAt,
    });

    return {
        type: "label",
        icon:
            icon === ValidityPeriodIconEnum.INFINITE
                ? infiniteImage
                : historyImage,
        label: text,
    };
};
